import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import {
  setLimit,
  setPage,
  setTotal,
  setColumnVisibility,
  setFailedSendCreditTasksTableFilters,
  setClearFailedSendCreditTasksTableFilters,
} from '@Modal/reducers/failedSendCreditTasks/failedSendCreidtTasksTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';

export const useFailedSendCreditTasksTable = () => {
  const dispatch = useDispatch();

  const {
    page,
    limit,
    total,
    selectedFilters,
    columnVisibility,
    columnVisibilityOptions,
    failedSendCreditTasksTableFilters,
  } = useSelector((state: StoreInterface) => state?.failedSendCreditTasksTable);

  const failedSendCreditTasksListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...failedSendCreditTasksListFilters, ...column];
    if (failedSendCreditTasksListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = failedSendCreditTasksListFilters.filter(
        (col) => col !== column[0]
      );
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setFailedSendCreditTasksTableFilters(filter));
  };

  const handleClearFailedSendCreditTasksTableFilters = () => {
    dispatch(setClearFailedSendCreditTasksTableFilters());
  };

  return {
    // State
    page,
    total,
    limit,
    selectedFilters,
    columnVisibility,
    visiblityCustomizable,
    columnVisibilityOptions,
    failedSendCreditTasksListFilters,
    failedSendCreditTasksTableFilters,
    // Actions
    setLimit,
    setPage,
    setTotal,
    setFailedSendCreditTasksTableFilters,
    setClearFailedSendCreditTasksTableFilters,
    // Handlers
    handleFilterSelect,
    handleApplyColumnVisibility,
    handleClearFailedSendCreditTasksTableFilters,
  };
};
